import { _toastVariants } from "../../utils/Constant";
import { formatFileURL, getFileUrl, validateDocumentFileType, validateImageFileType } from "../../utils/helper/appHelpers";
import { showMessage } from "../../utils/toast/globalToast";

const UploadDoucments = ({ formikProp }) => {
    const { values, setFieldValue, errors, touched } = formikProp
    return (
        <>
            <div className="col-md-12 mt-4">
                <br />
                <div className="d-flex align-items-center justify-content-between">
                    <label htmlFor="" className="label-input mb-1">
                        Upload Branch Documents <span className="text-danger">*</span>
                    </label>
                    <br />
                    <i
                        data-bs-toggle="tooltip"
                        className="fa fa-info-circle"
                        style={{ color: "#C1C9C9" }}
                        aria-hidden="true"
                        title="Upload branch related attachments such as license, registration certificate, etc."
                    ></i>
                </div>
                {values.documents.map((doc, docIndex) => (
                    <div
                        key={docIndex}
                        className="card mb-2 shadow-sm rounded-3 position-relative"
                    >
                        <div className="card-body">
                            <div className="row aic">
                                {/* Type */}
                                <div className="col-md-4">
                                    <label className="label-input">Type</label>
                                    <input
                                        type="text"
                                        className="form-control login-input"
                                        placeholder="Certificate type"
                                        onChange={(e) => {
                                            const newDocs = [...values.documents];
                                            newDocs[docIndex].name = e.target.value;
                                            setFieldValue("documents", newDocs);
                                        }}
                                        value={doc.name}
                                    />
                                </div>

                                {/* Expiry */}
                                <div className="col-md-4">
                                    <label className="label-input">Expiry</label>
                                    <input
                                        type="date"
                                        className="form-control login-input"
                                        min={new Date().toISOString().split("T")[0]}
                                        onChange={(e) => {
                                            const newDocs = [...values.documents];
                                            newDocs[docIndex].expiryDate = e.target.value;
                                            setFieldValue("documents", newDocs);
                                        }}
                                        value={doc.expiryDate}
                                    />
                                </div>

                                {/* Upload */}
                                <div className="col-md-4">
                                    <label className="label-input">Document</label>
                                    <input
                                        type="file"
                                        id={`uploadDoc-${docIndex}`}
                                        className="d-none form-control"
                                        onChange={async (e) => {
                                            const [file] = e.target.files;
                                            if (!file) return;
                                            // File size check (2 MB max)
                                            const maxSize = 2 * 1024 * 1024;
                                            if (file.size > maxSize) {
                                                return showMessage({
                                                    variant: _toastVariants.Error,
                                                    message: "File size should not exceed 2 MB",
                                                });
                                            }
                                            const isValid = validateDocumentFileType(file.type);
                                            if (!isValid) {
                                                return showMessage({
                                                    variant: _toastVariants.Error,
                                                    message: "Unsupported file type",
                                                });
                                            }

                                            const newDocs = [...values.documents];
                                            newDocs[docIndex].attachments = [
                                                ...newDocs[docIndex].attachments,
                                                file,
                                            ];
                                            setFieldValue("documents", newDocs);
                                        }}
                                    />
                                    <label
                                        htmlFor={`uploadDoc-${docIndex}`}
                                        className="form-control login-input mb-0"
                                        style={{ cursor: "pointer" }}
                                    >
                                        + Add
                                    </label>
                                </div>

                                <div className="col-md-12">
                                    {/* Preview */}
                                    {doc.attachments.length > 0 && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "20px",
                                                        flexWrap: "wrap",
                                                    }}
                                                >
                                                    {doc.attachments.map((item, index) => (
                                                        <div key={index} className="uploaddiv">
                                                            <img
                                                                src={typeof item == "string" ? formatFileURL(item) : getFileUrl(item)}
                                                                className="uploadimages"
                                                                alt=""
                                                            />
                                                            <div
                                                                onClick={() => {
                                                                    const newDocs = [
                                                                        ...values.documents,
                                                                    ];
                                                                    newDocs[docIndex].attachments = newDocs[
                                                                        docIndex
                                                                    ].attachments.filter((_, i) => i !== index);
                                                                    setFieldValue(
                                                                        "documents",
                                                                        newDocs
                                                                    );
                                                                }}
                                                            >
                                                                <img
                                                                    src="/images/close.svg"
                                                                    className="closeimg"
                                                                    alt="remove"
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Cross Button */}
                                <div>
                                    {docIndex !== 0 && (
                                        <span
                                            className="badge doc-c-btn"
                                            onClick={() => {
                                                const newDocs = values.documents.filter(
                                                    (_, i) => i !== docIndex
                                                );
                                                setFieldValue("documents", newDocs);
                                            }}
                                        >
                                            X
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                        {touched?.documents && errors?.documents ? (
                            <span style={{ fontSize: '14px', color: 'red' }}>{errors?.documents}</span>
                        ) : ''}
                    </div>
                ))}
            </div>

        </>
    )
}

export default UploadDoucments